import mySiema from '../vendors/siemaExtends';

export default class CarouselMobile {
    options: any;

    constructor(options?: object) {
        this.options = CarouselMobile.updateSettings(options);
    }

    static updateSettings(userSettings) {
        let defaultSettings = {
            carouselEl: ".siema.is-mobile-carousel",
            slidesWrapperEl: <any>".siema-slides-wrapper",
            arrowsCopy: {
                previous: `<span aria-label="previous image" class="icon icon-angle-left"></span>`,
                next: `<span aria-label="next image" class="icon icon-angle-right"></span>`
            }
        };

        for (const attrname in userSettings) {
            defaultSettings[attrname] = userSettings[attrname];
        }

        defaultSettings.slidesWrapperEl = (<NodeList>document.querySelectorAll(`${defaultSettings.carouselEl} ${defaultSettings.slidesWrapperEl}`));

        return defaultSettings;
    }

    init() {
        if (this.options.slidesWrapperEl.length) {

            const _this = this;

            Array.prototype.forEach.call(this.options.slidesWrapperEl, function (el) {
                new mySiema({
                    selector: el,
                    duration: 300,
                    easing: 'ease-in-out',
                    perPage: {
                        0: 1,
                        650: 2,
                        750: 3
                        },
                    offset: {
                        0: 0.28,
                        375: 0.4,
                        500: 0.5,
                        650: 0.28,
                        750: 0.13
                    },
                    onInit: function () {
                        this.paginationInit(_this.options);
                        //this.arrowsInit(_this.options);
                    },
                    onChange: function () {
                        this.paginationUpdate(_this.options);
                        //this.arrowsUpdate(_this.options);
                    }
                });
            });
        }
    }
}